import React from 'react';

import { Container, UsenPhoto, MessageWrapper, MessageSender, MessageData, MessageLine, MessageTime, LabelText, DiceStreak, LabelStreak, Rule, RuleTitle, SeparatorLine } from './ChatMessage.styles';
import Notification from './Notification/Notification';
import DiceResult from './DiceResult/DiceResult';
import ChatRuleDescription from './ChatRuleDescription';

export default ({message}) => {

    const renderComand = (msg) => {
        switch(msg.command) {
            case 'text':
                return msg.content;

            case 'notification-enter':
                return <Notification type={'enter'}>{msg.content}</Notification>;

            case 'notification-leave':
                return <Notification type={'leave'}>{msg.content}</Notification>;

            case 'roll':
                return <DiceResult content={msg.content} />;

            case 'silentroll':
                return <DiceResult silent={true} content={msg.content} />;

            case 'totalroll':
                return <DiceResult total={true} content={msg.content} />;

            case 'silenttotalroll':
                return <DiceResult silent={true} total={true} content={msg.content} />;

            case 'hiddenroll':
                return <DiceResult hidden={true} silent={true} total={true} content={msg.content} />;

            case 'multiroll':
                return <DiceStreak>
                    {msg.content && msg.content.map((roll, i) => <DiceResult key={i} silent={true} total={true} content={roll} />)}
                </DiceStreak>;

            case 'label':
                return <LabelText>{msg.content}</LabelText>;
                
            case 'multilabel':
                return <LabelStreak>
                    {msg.content.split('|').map((i,j) => <LabelText key={j}>{i.trim()}</LabelText>)}
                </LabelStreak>

            case 'rule':
                return <Rule>
                    <RuleTitle>{msg.content[0]}</RuleTitle>
                    <ChatRuleDescription>{msg.content[1]}</ChatRuleDescription>
                </Rule>

            case 'line':
                return <SeparatorLine />;

            default: 
                return null;
        }
    }
    return <Container>
        {message.userId ? <>
            <UsenPhoto color={message.color}>{message.initial}</UsenPhoto>
            <MessageWrapper>
                <MessageSender color={message.color}>{message.name}</MessageSender>
                <MessageData>
                    { message.messages.map((msg, i) => <MessageLine key={i}>
                        {renderComand(msg)}
                    </MessageLine>) }
                </MessageData>
                <MessageTime>{message.time}</MessageTime>
            </MessageWrapper>
        </> : renderComand(message.messages[0])}
    </Container>
};